import { ActivityLog } from '@api/ActivityLogs/ActivityLog';
import ActivityLogServ from '@api/ActivityLogs/ActivityLogServ';

class ActivityLogsService {
    getActivityLogs = (section: string, sectionId: string): Promise<ActivityLog[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await ActivityLogServ.getActivityLogs(section, sectionId);
                resolve(data);
            } catch (error) {
                console.log(error);
                reject('Error getting activity logs: ' + error);
            }
        });
    };
    deleteActivityLog = (activityLogId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await ActivityLogServ.deleteActivityLog(activityLogId);
                resolve();
            } catch (error) {
                console.log(error);
                reject('Error deleting activity log: ' + error);
            }
        });
    };
}
export default ActivityLogsService;
